// removed by extract-text-webpack-plugin
module.exports = {"component":"_1Y_5gC7AwEfKv_rPTox8VP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/WSLP/WSLP.scss
 ** module id = 1100
 ** module chunks = 0
 **/